import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import LightBoxPhotoList from '../../components/LightBoxPhotoList';

const styles = css`
  width: 100%;
`;

function DetailPhotoGallery({ community }) {
  return (
    <div className={styles}>
      <LightBoxPhotoList
        show={8}
        photos={get(community, 'photos')}
      />
    </div>
  );
}

DetailPhotoGallery.propTypes = {
  community: PropTypes.object.isRequired,
};

export default withData(
  {
    community: true,
  },
  {
    required: {
      community: true,
    },
  },
)(DetailPhotoGallery);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/DetailPhotoGallery.js